module.exports = __webpack_public_path__ + "assets/Retina-ExLight.6d033473263c1e685ee669cbbd7aceba.woff2";